export default __webpack_public_path__ + "static/media/CNo.63-0.6018eb7f.jpg";